import React from 'react'

const CollapsIcon = () => {
    return (
<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16">
  <path id="Path_21175" data-name="Path 21175" d="M16.707,31.293a1,1,0,0,0-1.414,0l-7,7a1,1,0,0,0,0,1.414l7,7a1,1,0,0,0,1.414-1.414L10.414,39l6.293-6.293A1,1,0,0,0,16.707,31.293Zm-8,0a1,1,0,0,0-1.414,0l-7,7a1,1,0,0,0,0,1.414l7,7a1,1,0,1,0,1.414-1.414L2.414,39l6.293-6.293A1,1,0,0,0,8.707,31.293Z" transform="translate(0 -31)" fill="#fff" fill-rule="evenodd" />
</svg>

)
}

export default CollapsIcon